export default __webpack_public_path__ + "static/media/riftscc.2ef32581.jpg";